import {
    TRACKING_PLATFORM_TYPE_RESPONSIVE,
    TRACKING_SITE_AREA_MOBILITY,
    TRACKING_PAGE_TYPE,
    TRACKING_OFORM_NAME,
    TRACKING_OFORM_TYPE,
    TRACKING_OFORM_FORMSTEP_ONE,
    TRACKING_OFORM_FORMSTEP_TWO,
    TRACKING_OFORM_FORMSTEP_NAME,
    TRACKING_OFORM_FORMSTEP_NAME_SUCCESS,
    TRACKING_OFORM_FORM_STATUS_START,
    TRACKING_OFORM_FORM_STATUS_SUCCESS,
} from '../../constant';

/**
 * initTracking
 * @param siteStructure, loginStatus
 */
export const initTracking = (siteStructure: string[], loginStatus: string) => {
    const trackingPayload = {
        tealiumUseDCF: true,
        pageType: TRACKING_PAGE_TYPE,
        loginStatus,
        siteArea: TRACKING_SITE_AREA_MOBILITY,
        platformType: TRACKING_PLATFORM_TYPE_RESPONSIVE,
        siteStructure: [...siteStructure],
        oForm: {
            name: TRACKING_OFORM_NAME,
            type: TRACKING_OFORM_TYPE,
            formStep: TRACKING_OFORM_FORMSTEP_ONE,
            formStepName: TRACKING_OFORM_FORMSTEP_NAME,
            formStatus: [TRACKING_OFORM_FORM_STATUS_START],
            context: (window as any).additionalPageOptions.gemeinde,
        },
    };

    trackingPayload.siteStructure.push( (window as any).additionalPageOptions.gemeinde);

    return {...trackingPayload};
};

/**
 * track notification
 *
 */
export const successNotificationTracking = (siteStructure: string[], loginStatus: string) => {
    const trackingPayload = initTracking(siteStructure, loginStatus);

    trackingPayload.siteStructure.push( TRACKING_OFORM_FORMSTEP_NAME_SUCCESS);
    trackingPayload.oForm.formStep = TRACKING_OFORM_FORMSTEP_TWO;
    trackingPayload.oForm.formStepName = TRACKING_OFORM_FORMSTEP_NAME_SUCCESS;
    trackingPayload.oForm.formStatus = TRACKING_OFORM_FORM_STATUS_SUCCESS;

    return {
        ...trackingPayload,
    };

};
